// extracted by mini-css-extract-plugin
module.exports = {"commonContainer":"forgot_commonContainer__2JS-W","formContainer":"forgot_formContainer__1ZIzL","buttonContainer":"forgot_buttonContainer__ExgH5"};